import {
  LineChart,
  Target,
  ShieldCheck,
  PiggyBank,
  Landmark,
  RefreshCw,
} from "lucide-react";

export const BRAND = {
  name: "Mohd Aamir",
  arn: "ARN-280363",
  tagline: "Wealth Management & Mutual Fund Distribution",
  phones: ["8840799595", "9044991242"],
  email: "aamir.trader09@gmail.com",
  whatsapp: "918840799595",
  amfi: "Member of Association of Mutual Funds in India (AMFI)",
};

export const NAV_LINKS = [
  { label: "Philosophy", href: "#philosophy" },
  { label: "Services", href: "#services" },
  { label: "Calculators", href: "#calculators" },
  { label: "Stories", href: "#stories" },
  { label: "FAQ", href: "#faq" },
];

export const SERVICES = [
  {
    icon: RefreshCw,
    title: "SIP Planning",
    desc: "Disciplined, automated monthly investing engineered to harness the power of rupee-cost averaging and long-term compounding.",
  },
  {
    icon: Target,
    title: "Goal-Based Investing",
    desc: "Every rupee mapped to a purpose — a home, a child's education, a dream — with a portfolio built backwards from your milestone.",
  },
  {
    icon: PiggyBank,
    title: "Tax-Saving (ELSS)",
    desc: "Grow wealth while you save under Section 80C, with the shortest lock-in among 80C instruments and equity-linked upside.",
  },
  {
    icon: LineChart,
    title: "Portfolio Review",
    desc: "Periodic, data-driven rebalancing to keep your allocation aligned with markets, goals, and evolving risk appetite.",
  },
  {
    icon: Landmark,
    title: "Retirement Planning",
    desc: "A calm, inflation-aware roadmap that turns today's surplus into a dignified, self-funded tomorrow.",
  },
  {
    icon: ShieldCheck,
    title: "Risk Profiling",
    desc: "Honest conversations and structured assessment so your investments match the risk you can genuinely stomach.",
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Patience compounds.",
    body: "Markets reward the disciplined, not the anxious. We build portfolios designed to be held through cycles, letting time — the most underrated asset — do the heavy lifting.",
  },
  {
    no: "02",
    title: "Clarity over noise.",
    body: "No hot tips, no market timing theatre. Just a transparent process, plain-language reporting, and decisions you fully understand before you commit a single rupee.",
  },
  {
    no: "03",
    title: "Goals, not products.",
    body: "A mutual fund is a tool, never the destination. Every recommendation begins with your life — the milestones you're funding — and works backwards to the right instrument.",
  },
];

export const STATS = [
  { value: 250, suffix: "+", label: "Families Guided" },
  { value: 12, suffix: " Yrs", label: "Advisory Experience" },
  { value: 40, prefix: "\u20B9", suffix: " Cr+", label: "Assets Advised" },
  { value: 98, suffix: "%", label: "Client Retention" },
];

export const TESTIMONIALS = [
  {
    quote:
      "Aamir turned my scattered savings into a clear plan. My first SIP was five years ago — today I'm funding my daughter's education without stress.",
    name: "Rukhsar Parveen",
    role: "School Teacher, Lucknow",
  },
  {
    quote:
      "What sets him apart is honesty. He talked me out of a risky bet that didn't fit my goals. That single conversation earned my trust for life.",
    name: "Anil Kumar Verma",
    role: "Small Business Owner",
  },
  {
    quote:
      "Transparent, patient, always reachable. My retirement corpus is finally on track and I actually understand where every rupee sits.",
    name: "Fatima Sheikh",
    role: "Government Employee",
  },
];

export const FAQS = [
  {
    q: "What is a SIP and why start one?",
    a: "A Systematic Investment Plan invests a fixed amount into a mutual fund at regular intervals. It instils discipline, averages out market volatility, and lets compounding work over the long term — you can begin with as little as \u20B9500 a month.",
  },
  {
    q: "Are my investments safe?",
    a: "Mutual funds are regulated by SEBI and held with SEBI-registered custodians. While returns are subject to market risk, your holdings are transparent, in your own name, and can be redeemed anytime (subject to scheme terms).",
  },
  {
    q: "How do you charge for your services?",
    a: "As an AMFI-registered mutual fund distributor (ARN-280363), I earn a standard commission from the Asset Management Companies — there is typically no separate advisory fee charged to you. Everything is disclosed upfront.",
  },
  {
    q: "Can I withdraw my money whenever I need it?",
    a: "Open-ended funds allow redemption on any business day. ELSS tax-saving funds carry a 3-year lock-in. We always plan liquidity around your goals so money is available when you need it.",
  },
  {
    q: "How do we get started?",
    a: "Reach out via the enquiry form or WhatsApp. We'll have a no-obligation conversation about your goals, complete a quick risk assessment, and build your first plan together.",
  },
];

export const DISCLAIMER =
  "Mutual Fund investments are subject to market risks. Please read all scheme related documents carefully before investing. Past performance is not indicative of future returns.";
